"use client";
import * as React from "react";
import { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { faqData } from "../../dummydata/navBarData.js";
import { Grid, Typography } from "@mui/material";

interface FaqAccordianProps {
  seoContent: any;
}

const FaqAccordian: React.FC<FaqAccordianProps> = ({ seoContent }) => {
  const [expanded, setExpanded] = useState(Array(faqData.length).fill(false));

  const handleChange = (index: any) => () => {
    setExpanded((prevExpanded) => {
      const newExpanded = [...prevExpanded];
      newExpanded[index] = !newExpanded[index];
      return newExpanded;
    });
  };

  return (
    <Grid
      container
      item
      md={9.5}
      lg={9.5}
      sx={{
        margin: "var(--salontym-section-gap) auto",
        maxWidth: "min(100%, 52rem)",
        width: "100%",
      }}
    >
      <Typography
        component="h2"
        variant="h5"
        sx={{
          pb: 2,
          textAlign: "center",
          width: "100%",
          color: "#102117",
          fontWeight: 800,
        }}
      >
        Frequently asked questions
      </Typography>
      <div style={{ width: "100%" }}>
        {seoContent?.seoContentItems?.map((item: any, index: number) => (
            <Accordion
              key={`faq-${index}-${item?.title ?? ""}`}
              expanded={expanded[index]}
              onChange={handleChange(index)}
              aria-controls={`item${index}-content`}
              id={`item${index}-header`}
              sx={{
                width: "100%",
                padding: "2px",
                // background: "#e5efe7",
                // background: "rgb(21, 116, 26)",
                // color: "white",
                // border: "none",
                // boxShadow: "none",
                "&::before": {
                  // display: "none",
                },
              }}
            >
              <AccordionSummary
                expandIcon={
                  expanded[index] ? (
                    <RemoveCircleIcon style={{ color: "#1f7a4d" }} />
                  ) : (
                    <AddCircleIcon style={{ color: "#1f7a4d" }} />
                  )
                }
                aria-controls={`item${index}-content`}
                id={`item${index}-header`}
              >
                <Typography variant="body2" sx={{ fontWeight: 600, color: "#102117" }}>
                  {item.title}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body2" sx={{ color: "#858181c9" }}>
                  {item.content}
                </Typography>
                {/* chnage text to content */}
              </AccordionDetails>
            </Accordion>
        ))}
      </div>
    </Grid>
  );
};

export default FaqAccordian;
